import _ from "underscore";
import stores from "../../../stores";
import C from "../constants";
const {INITIAL_ASN_RELATED_SNAPSHOT} = C;

let singleton;

const storeConfig = {
  AsnStore: {
    only: [
      // Location Tab Info 
      "facilities",
      "cadId",
      "cadAddress1",
      "cadAddress2",
      "cadCountry",
      "cadCity",
      "state",
      "cadZipcode",
      "cadStateText",
      // Shipping Tab Info
      "shippingPartner",
      // don't need inbound carrier
      // "inboundCarrier",
      "insidePickup",
      "liftGatePickup",
      "limitedAccess",
      "lumperPickup",
      "driverLoad",
      "pickupDate",
      "pickupTimeFrom",
      "pickupTimeTo",
      "shippingMethod",
      "freightShipping",
      "caseShipping"
    ]
  },
  AsnDetailStore: {
    // just compare everything in this store,
    // technically it doesn't matter
  }
};


export default function asnInitialSnapshotChangedFactory(options){
  if(singleton){
    // singleton.setOptions(options);
    return singleton;
  }
  else{
    singleton = new AsnInitialSnapshotChanged(options);
    singleton.init();
    return singleton;
  }
}

function AsnInitialSnapshotChanged(){
  const self = this;

  this.init = function(){

  }

  self.didStoresDataChange = didStoresDataChange;

  function didStoresDataChange(){
    return didAsnStoreChange() || didAsnDetailStoreChange();
  }


  function didAsnStoreChange(){
    const {only} = storeConfig.AsnStore;
    const asn = getCurrentAsn();
    const asnId = asn.id;

    // check if quote are not already invalidated, AND (that we actually have quotes OR specialQuote flag is true), AND we have a snapshot, and that there are changes since the last snapshot
    return AsnStore.getDataSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT) && AsnStore.hasDataChangesSinceSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT, {id: asnId, only});
  }

  function didAsnDetailStoreChange(){
    return AsnDetailStore.getDataSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT) && AsnDetailStore.hasDataChangesSinceSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT);
  }

  function getCurrentAsnId(){
    return getCurrentAsn().id;
  }

  function getCurrentAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }
}


// WEBPACK FOOTER //
// ./src/pages/asns/businessLogic/asnInitialSnapshotChangedFactory.js